<template lang="pug">
.technology__container.row-container
  .col-container
    h1.technology__title
      | Технологии
    p.technology__subtitle
      | Как мы работаем, технологии.

    .technology__section
      .technology__section-text
        h3.technology__section-title Стек технологий
        p.technology__section-subtitle
          b Сервер:
          |   Django, FastAPI, Python, Nginx, Traefik
          br
          b DevOps:
          |   Gitlab CI/CD, Docker, Portainer
          br
          b Фоновые задачи:
          |   Celery, RabbitMQ
          br
          b Фронтенд:
          |   Vue.js, JavaScript, Webpack
          br
          b Базы данных:
          |   PostgreSQL, Redis, Pgbouncer
          br
          b Мониторинг:
          |   Sentry.io, Datadog
          br
          b API Gateway:
          |   APISIX
          br
          b Auth:
          |   Keycloak
          br
          b Tests:
          |   Postman, Selenium, schemathesis, pytest
          br
          b Хостинг:
          |   YandexCloud, Selectel, VDS.Selectel, DigitalOcean, Vscale, Hetzner
          br
          b Real-time:
          |   Centrifuge, WebSockets, WebRTC
          br
          b Мобильная разработка:
          |   Flutter.dev
        .technology__bridge
      picture
        source(type="image/webp" srcset="~assets/images/technology/technology_1.webp")
        img(src="~assets/images/technology/technology_1.png").technology__section-img
    .technology__section
      .technology__section-text
        h3.technology__section-title Поддержка браузеров
        div.technology__section-subtitle
          ul.technology__section-list
            li Chromium (Chrome, Edge Insider)
            li Firefox
            li Edge
            li Safari 10+
            li IE11 / Safari 9 (с polyfill)
            br
          b Не поддерживаем:
          |   IE9 / IE10
        .technology__bridge
      picture
        source(type="image/webp" srcset="~assets/images/technology/technology_2.webp")
        img(src="~assets/images/technology/technology_2.png").technology__section-img
    .technology__section
      .technology__section-text
        h3.technology__section-title
          | Мобильная разработка
        p.technology__section-subtitle
          b Mobile operating systems:
          |   Android Jelly Bean, v16, 4.1.x or newer, and iOS 8 or newer.
          br
          b Mobile hardware:
          |   iOS devices (iPhone 4S or newer) and ARM Android devices.
          br
          br
          b Note:
          |   Flutter currently does not support building for x86 Android (issue #9253) directly, however apps built for ARMv7 or ARM64 run fine (via ARM emulation) on many x86 Android devices.
      picture
        source(type="image/webp" srcset="~assets/images/technology/technology_3.webp")
        img(src="~assets/images/technology/technology_3.png").technology__section-img
    BaseFooter(:formValue="footer_data")
</template>

<script setup>
import { storeToRefs } from 'pinia'
import { useTechnologyStore } from '~/stores/technology'

const technologyStore = useTechnologyStore()
await technologyStore.setTechnologyPage()
const { title, footer_data, meta, og } = storeToRefs(technologyStore)

usePageHeadMeta(meta.value.title, meta.value.description, og.value)
</script>


<style lang="scss" scoped>
.technology {

  &__container {
    --indent: 64px;
    --indent-left: 110px;
    --line-width: 2px;
    --line-height: 160px;

    @media (min-width: 1024px) and (max-width: 1279px) {
      padding-left: 5vw;
      padding-right: 5vw;
    }

    @media only screen and (width: 1024px) and (max-height: 1366px) and (orientation: portrait) and (-webkit-min-device-pixel-ratio: 1.5) {
      padding-left: 10vw;
      padding-right: 10vw;
    }

    @media (min-width: $breakpoint-desktop) {
      --indent: 95px;
      --line-height: 307px;
    }
  }

  &__title {
    color: $primary;
    margin-bottom: 10px;
    font-size: 34px;

    @include l-desktop {
      margin-bottom: 5px;
    }
  }

  &__subtitle {
    color: $primary;
    margin-bottom: 60px;

    @media (min-width: $breakpoint-medium) {
      margin-bottom: 145px;
    }
  }

  &__section {
    width: 100%;
    display: flex;
    flex-direction: column-reverse;

    @media (min-width: $breakpoint-large) {
      flex-direction: row;
      justify-content: space-between;
    }
  }

  &__section+.technology__section {
    margin-top: 115px;

    @media (min-width: $breakpoint-large) {
      margin-top: 200px;
    }

    @media (min-width: $breakpoint-notebook) {
      margin-top: var(--indent);
    }
  }

  &__section-img {
    width: 100%;
    height: 165px;
    margin-bottom: 40px;
    object-fit: cover;
    object-position: 50% 50%;

    @media (min-width: $breakpoint-small) {
      height: 300px;
    }

    @media (min-width: $breakpoint-large) {
      width: auto;
      height: auto;
      margin-bottom: 0;
      margin-left: 20px;
      height: 345px;
      width: 689px;
    }

    @media only screen and (width: 1024px) and (max-height: 1366px) and (orientation: portrait) and (-webkit-min-device-pixel-ratio: 1.5) {
      height: auto;
      width: 489px;
    }
  }

  &__section-text {
    position: relative;
    max-width: 355px;
  }

  &__section-title {
    color: $dark;
    margin-bottom: 15px;
    text-transform: uppercase;
  }

  &__section-subtitle {
    color: $dark;
    line-height: 1.4;
    position: relative;
  }

  &__section-list {
    padding-left: 20px;
  }

  &__section-list>li {
    list-style: disc;
  }

  &__bridge {
    --circle-color: var(--main-color);

    display: none;
    position: relative;
    margin-left: var(--indent-left);
    border-left: var(--line-width) solid $primary;

    @media (min-width: $breakpoint-notebook) {
      display: block;
      height: var(--line-height);
      margin-top: var(--indent);
    }

    @include end-circle-vertical;
  }
}
</style>
